export default function SvgImageIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M19 21h1.01c.97 0 1.456 0 1.724-.203a1 1 0 00.395-.737c.02-.335-.25-.74-.788-1.547l-3.01-4.516c-.446-.668-.668-1.002-.949-1.118a1 1 0 00-.766 0c-.28.116-.503.45-.948 1.118l-.744 1.116M18.999 21L11.315 9.9c-.442-.638-.663-.957-.94-1.07a1 1 0 00-.752 0c-.276.113-.497.432-.94 1.07l-5.946 8.59c-.563.813-.844 1.22-.828 1.557a1 1 0 00.391.747c.27.206.764.206 1.753.206h14.946zm2-15a3 3 0 11-6 0 3 3 0 016 0z"
      ></path>
    </svg>
  )
}
